import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Form, Nav } from 'tmt-ui-kit';

const FilterDropdownContainer = styled.div`
  display: flex;
  justify-content: center;

  @media only screen and (max-width: 600px){
    flex-direction: ${props => (props.navbar ? 'row' : 'column')};
  }
`;
const ItemFilterDropdown = styled.div`
  box-sizing: border-box;
  width: 214px;
  height: 40px;
  padding-left: 10px;
  border-radius: 6px;
  background: ${props => props.theme.white};
  text-align: left;
  margin-right: 16px;

  @media only screen and (max-width: 600px){
    ${props => (props.navbar ? `
        margin-right: 8px;
    ` : `
      margin: 8px 0;
    `)}
    > div > p {
      font-size: 14px !important;
    }
  }
  @media only screen and (max-width: 320px){
    ${props => (props.navbar && `
        width: 184px;
        margin-right: 4px;
    `)}
  }
`;

// const Topic = styled(Typo.Paragraph)`
//   margin-top: 9px !important;
// `;

const ButtonDropdown = styled(Form.Button.BlueButton)`
  width: 136px;
  @media only screen and (max-width: 600px){
    ${props => (props.navbar && 'width: 110px;')}
  }
`;

const FilterDropdown = (props) => {
  const {
    navbar,
    optionDestinations,
    placeholderCity,
    optionsActivity,
    city,
    activity,
    isShowByPage
  } = props;
  return (
    <FilterDropdownContainer navbar={navbar}>
      {(isShowByPage.pathname === '/city') && (
        <ItemFilterDropdown fisrt navbar={navbar}>
          <Nav.Dropdown
            selected={city}
            options={optionDestinations}
            placeholder={placeholderCity}
            handleOnChange={(e) => props.onChangeFilter(e.target.value, 'city')}
          />
        </ItemFilterDropdown>
      )}
      {(isShowByPage.pathname === '/search/activity' || navbar) && (
        <ItemFilterDropdown last navbar={navbar}>
          <Nav.Dropdown
            selected={activity}
            options={optionsActivity}
            handleOnChange={(e) => props.onChangeFilter(e.target.value, 'activity')}
          />
        </ItemFilterDropdown>
      )}
      <ButtonDropdown navbar={navbar} disabled={props.isDisabled} onClick={props.onClickFilter}>Find</ButtonDropdown>
    </FilterDropdownContainer>
  );
};

FilterDropdown.propTypes = {
  onClickFilter: PropTypes.func,
  onChangeFilter: PropTypes.func,
  optionDestinations: PropTypes.array,
  optionsActivity: PropTypes.array,
  navbar: PropTypes.bool,
  placeholderCity: PropTypes.string,
  city: PropTypes.string,
  activity: PropTypes.string,
  isShowByPage: PropTypes.object,
  isDisabled: PropTypes.bool
};

export default FilterDropdown;
